export default "__VITE_ASSET__c8533c9a__"